export const CUSTOM_OBJECTS_STRINGS = {
  tabLabel: 'Custom Objects',
  schemaPickerLabel: 'Object type',
  schemaPickerPlaceholder: 'Choose an object type',
  chooseSchemaPrompt: 'Choose an object type to view its records.',
  noSchemasTitle: 'No custom object types',
  noSchemasDescription: 'Custom object types you define in Data Integration will appear here.',
  noSchemasLink: 'Go to Data Integration',
  loadingSchemas: 'Loading object types...',
  loadSchemasError: 'Failed to load object types',
  loadingRecords: 'Loading records...',
  searchPlaceholder: 'Find by exact external ID...',
  searchLabel: 'Find by exact external ID',
  noRecordsTitle: 'No records',
  noRecordsDescription: 'This tenant has no records of this type yet.',
  noMatchesDescription: 'No record has that exact external ID.',
  externalIdColumn: 'External ID',
  previousPage: 'Previous',
  nextPage: 'Next',
  loadError: 'Failed to load records',
} as const satisfies Record<string, string>;
